export interface PreviewInterface {
  videosUrls: string[];
}

export const enum STATES {
  IDLE = 'idle',
  ERROR = 'error',
  FINISH = 'finish',
}

export const enum EVENTS {
  TAKES_RECEIVED = 'TAKES_RECEIVED',
}

export const enum ACTIONS {
  SET_TAKES = 'setTakes',
}
